<template>
  <div class="flex items-center gap-1.5">
    <UseSvg icon="sparkles-gradient" class="h-6 w-6 shrink-0" />
    <h3 class="text-sm !font-medium leading-6 text-neutral-950">{{ title }}</h3>
    <span
      class="rounded-full border border-white bg-green-700 px-1.5 py-0.5 text-xs font-medium text-white"
    >
      Free
    </span>
    <div class="ml-auto">
      <button
        ref="howItWorksButtonRef"
        type="button"
        class="cursor-pointer border-0 bg-transparent p-0 text-xs !text-blue-700 underline"
        data-testid="how-it-works-button"
        @click="$emit('how-it-works-click')"
        @mouseenter="$emit('how-it-works-mouseenter')"
        @mouseleave="$emit('how-it-works-mouseleave')"
      >
        How it works
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";

import UseSvg from "common/vue/components/UseSvg.vue";

defineOptions({ name: "ArtistEditsHeader" });

defineProps({
  title: { type: String, required: true }
});

defineEmits(["how-it-works-click", "how-it-works-mouseenter", "how-it-works-mouseleave"]);

const howItWorksButtonRef = ref(null);

defineExpose({ howItWorksButtonRef });
</script>
